<template>
  <v-container fluid>
    <div class='tableauPlaceholder' style='width: 1440px; height: 674px;'><object class='tableauViz' width='1440' height='674' style='display:none;'><param name='host_url' value='https%3A%2F%2Fanalytics.outfox.ai%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='' /><param name='name' value='ThePeople-VAGOTV/Candidates' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /></object></div>
</v-container>
</template>

<script>
import DevPlaceholder from '../../helpers/TheDevPlaceholder.vue'
export default {
  name: '',
  components: {
    DevPlaceholder
  },
  data () {
    return {}
  },
  methods: {},
  mounted () {
    let tableauScript = document.createElement('script')
    tableauScript.setAttribute('src', 'https://analytics.outfox.ai/javascripts/api/viz_v1.js')
    document.head.appendChild(tableauScript)
  }
}
</script>
